module.exports = __webpack_public_path__ + "img/icon-viper.e7a4f5b6.png";